import type { IconData } from '@stacksjs/iconify-core'

export const sortDescending: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M184 288h120v32H184zm0-72h184v32H184zm0-72h248v32H184zm0-72h312v32H184z\"/><path fill=\"currentColor\" d=\"M95.196 16v417.568l-51.883-51.882l-22.626 22.627l90.509 90.51l90.509-90.51l-22.627-22.626l-51.882 51.881V16z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default sortDescending
